import { colors } from '../../abstracts';
import { styled, css } from 'styled-components';
import { dontForwardProps } from '../../util';
export const CarouselIndicatorContainer = styled.div.withConfig(dontForwardProps()).withConfig({
  componentId: "aui__sc-yczs8n-0"
})(["display:flex;box-sizing:border-box;align-items:center;gap:0.5rem;", ";"], ({
  contained
}) => contained && css(["&&&{background-color:", ";padding:0.5rem;border-radius:1rem;}"], colors.white));
export const Indicator = styled.div.withConfig(dontForwardProps()).withConfig({
  componentId: "aui__sc-yczs8n-1"
})(["width:0.5rem;height:0.5rem;border-radius:16px;background-color:", ";transition:background-color 250ms ease-in-out;will-change:background-color;", " &[data-current='true']{transition:inherit;background-color:", ";}"], colors.neutralDeeper, ({
  indicatorType
}) => indicatorType === 'dots' ? css(["width:0.5rem;height:0.5rem;"]) : css(["width:2.625rem;height:0.25rem;"]), colors.black);